import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let parallaxTriggers = [];
const BANNER_WIDTH_ANIM_QUERY = "(min-width: 992px)";

function destroyBannerParallax() {
    parallaxTriggers.forEach((trigger) => trigger.kill());
    parallaxTriggers = [];
}

function initBannerParallax(root = document) {
    destroyBannerParallax();

    const sections = root.querySelectorAll(".block-banner__content[data-parallax-background-ratio]");
    const allowWidthAnim = window.matchMedia(BANNER_WIDTH_ANIM_QUERY).matches;

    sections.forEach((section) => {
        const imageWrapper = section.querySelector(".block__image-wrapper");
        const image = section.querySelector(".block__image");
        const startWidth = section.getAttribute("data-expand-start") || "54%";
        const endWidth = section.getAttribute("data-expand-end") || "100%";

        if (allowWidthAnim) {
            gsap.set(section, {
                width: startWidth,
                marginLeft: "auto",
                marginRight: "auto",
                boxSizing: "border-box",
                willChange: "width",
            });

            const widthTween = gsap.fromTo(
                section,
                { width: startWidth },
                {
                    width: endWidth,
                    ease: "none",
                    scrollTrigger: {
                        trigger: section,
                        start: "top bottom",
                        end: "top 60%",
                        scrub: true,
                        invalidateOnRefresh: true,
                    },
                }
            );

            if (widthTween.scrollTrigger) {
                parallaxTriggers.push(widthTween.scrollTrigger);
            }
        } else {
            gsap.set(section, { clearProps: "width,marginLeft,marginRight,willChange" });
        }

        const parallaxTarget = imageWrapper || image;

        if (parallaxTarget) {
            const ratio = parseFloat(section.getAttribute("data-parallax-background-ratio")) || 0.5;
            const sectionHeight = section.offsetHeight || 600;
            const parallaxDistance = Math.max(70, Math.round(sectionHeight * ratio * 0.45));
            const upDistance = parallaxDistance;
            const downDistance = parallaxDistance;
            const travelDistance = upDistance + downDistance;
            const coverOffset = Math.max(24, Math.round(travelDistance + 20));

            if (imageWrapper) {
                gsap.set(imageWrapper, {
                    top: -coverOffset,
                    bottom: -coverOffset,
                    height: "auto",
                });
            }

            gsap.set(parallaxTarget, { y: -upDistance, willChange: "transform", transformOrigin: "center center" });
            if (image) {
                gsap.set(image, { scale: 1, willChange: "transform", transformOrigin: "center center" });
            }

            const tween = gsap.to(parallaxTarget, {
                y: downDistance,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    invalidateOnRefresh: true,
                },
            });

            if (tween.scrollTrigger) {
                parallaxTriggers.push(tween.scrollTrigger);
            }
        }
    });

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            ScrollTrigger.refresh();
        });
    });
}

export { initBannerParallax, destroyBannerParallax };
